
// @ts-nocheck


export const localeCodes =  [
  "en-us",
  "uk-ua",
  "bg",
  "hr",
  "cs",
  "da",
  "nl",
  "et",
  "fi",
  "fr",
  "de",
  "el",
  "hu",
  "ga",
  "it",
  "lv",
  "lt",
  "mt",
  "pl",
  "pt",
  "ro",
  "sk",
  "sl",
  "es",
  "sv",
  "tr",
  "my",
  "fil",
  "ro-md",
  "dv",
  "hy",
  "sq",
  "bs",
  "sr",
  "ka",
  "ne",
  "vi",
  "ko",
  "he"
]

export const localeLoaders = {
  "en-us": [
    {
      key: "locale_en_46json_29ccb7a8",
      load: () => import("#nuxt-i18n/29ccb7a8" /* webpackChunkName: "locale_en_46json_29ccb7a8" */),
      cache: true
    }
  ],
  "uk-ua": [
    {
      key: "locale_ua_46json_bedfd313",
      load: () => import("#nuxt-i18n/bedfd313" /* webpackChunkName: "locale_ua_46json_bedfd313" */),
      cache: true
    }
  ],
  bg: [
    {
      key: "locale_bg_46json_ce5bf2c5",
      load: () => import("#nuxt-i18n/ce5bf2c5" /* webpackChunkName: "locale_bg_46json_ce5bf2c5" */),
      cache: true
    }
  ],
  hr: [
    {
      key: "locale_hr_46json_324f0a37",
      load: () => import("#nuxt-i18n/324f0a37" /* webpackChunkName: "locale_hr_46json_324f0a37" */),
      cache: true
    }
  ],
  cs: [
    {
      key: "locale_cs_46json_24c23cb3",
      load: () => import("#nuxt-i18n/24c23cb3" /* webpackChunkName: "locale_cs_46json_24c23cb3" */),
      cache: true
    }
  ],
  da: [
    {
      key: "locale_da_46json_b1ca0a2d",
      load: () => import("#nuxt-i18n/b1ca0a2d" /* webpackChunkName: "locale_da_46json_b1ca0a2d" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_77e32ac2",
      load: () => import("#nuxt-i18n/77e32ac2" /* webpackChunkName: "locale_nl_46json_77e32ac2" */),
      cache: true
    }
  ],
  et: [
    {
      key: "locale_et_46json_2fba23c6",
      load: () => import("#nuxt-i18n/2fba23c6" /* webpackChunkName: "locale_et_46json_2fba23c6" */),
      cache: true
    }
  ],
  fi: [
    {
      key: "locale_fi_46json_74721082",
      load: () => import("#nuxt-i18n/74721082" /* webpackChunkName: "locale_fi_46json_74721082" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_044e5f22",
      load: () => import("#nuxt-i18n/044e5f22" /* webpackChunkName: "locale_fr_46json_044e5f22" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_2b328bb6",
      load: () => import("#nuxt-i18n/2b328bb6" /* webpackChunkName: "locale_de_46json_2b328bb6" */),
      cache: true
    }
  ],
  el: [
    {
      key: "locale_el_46json_3255f603",
      load: () => import("#nuxt-i18n/3255f603" /* webpackChunkName: "locale_el_46json_3255f603" */),
      cache: true
    }
  ],
  hu: [
    {
      key: "locale_hu_46json_4dcba0e8",
      load: () => import("#nuxt-i18n/4dcba0e8" /* webpackChunkName: "locale_hu_46json_4dcba0e8" */),
      cache: true
    }
  ],
  ga: [
    {
      key: "locale_ga_46json_7f10bea0",
      load: () => import("#nuxt-i18n/7f10bea0" /* webpackChunkName: "locale_ga_46json_7f10bea0" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_9c203c17",
      load: () => import("#nuxt-i18n/9c203c17" /* webpackChunkName: "locale_it_46json_9c203c17" */),
      cache: true
    }
  ],
  lv: [
    {
      key: "locale_lv_46json_8cba9add",
      load: () => import("#nuxt-i18n/8cba9add" /* webpackChunkName: "locale_lv_46json_8cba9add" */),
      cache: true
    }
  ],
  lt: [
    {
      key: "locale_lt_46json_969c3f24",
      load: () => import("#nuxt-i18n/969c3f24" /* webpackChunkName: "locale_lt_46json_969c3f24" */),
      cache: true
    }
  ],
  mt: [
    {
      key: "locale_mt_46json_a9674e88",
      load: () => import("#nuxt-i18n/a9674e88" /* webpackChunkName: "locale_mt_46json_a9674e88" */),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_46json_1ce4a4a5",
      load: () => import("#nuxt-i18n/1ce4a4a5" /* webpackChunkName: "locale_pl_46json_1ce4a4a5" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_46json_c7df3837",
      load: () => import("#nuxt-i18n/c7df3837" /* webpackChunkName: "locale_pt_46json_c7df3837" */),
      cache: true
    }
  ],
  ro: [
    {
      key: "locale_ro_46json_37b1803f",
      load: () => import("#nuxt-i18n/37b1803f" /* webpackChunkName: "locale_ro_46json_37b1803f" */),
      cache: true
    }
  ],
  sk: [
    {
      key: "locale_sk_46json_8a2864b9",
      load: () => import("#nuxt-i18n/8a2864b9" /* webpackChunkName: "locale_sk_46json_8a2864b9" */),
      cache: true
    }
  ],
  sl: [
    {
      key: "locale_sl_46json_747c20d6",
      load: () => import("#nuxt-i18n/747c20d6" /* webpackChunkName: "locale_sl_46json_747c20d6" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_5f98cce4",
      load: () => import("#nuxt-i18n/5f98cce4" /* webpackChunkName: "locale_es_46json_5f98cce4" */),
      cache: true
    }
  ],
  sv: [
    {
      key: "locale_sv_46json_0b5635a5",
      load: () => import("#nuxt-i18n/0b5635a5" /* webpackChunkName: "locale_sv_46json_0b5635a5" */),
      cache: true
    }
  ],
  tr: [
    {
      key: "locale_tr_46json_c05cf1a6",
      load: () => import("#nuxt-i18n/c05cf1a6" /* webpackChunkName: "locale_tr_46json_c05cf1a6" */),
      cache: true
    }
  ],
  my: [
    {
      key: "locale_my_46json_eeaf82cf",
      load: () => import("#nuxt-i18n/eeaf82cf" /* webpackChunkName: "locale_my_46json_eeaf82cf" */),
      cache: true
    }
  ],
  fil: [
    {
      key: "locale_fil_46json_471d6cee",
      load: () => import("#nuxt-i18n/471d6cee" /* webpackChunkName: "locale_fil_46json_471d6cee" */),
      cache: true
    }
  ],
  "ro-md": [
    {
      key: "locale_ro_45md_46json_46bac38a",
      load: () => import("#nuxt-i18n/46bac38a" /* webpackChunkName: "locale_ro_45md_46json_46bac38a" */),
      cache: true
    }
  ],
  dv: [
    {
      key: "locale_dv_46json_96a088e8",
      load: () => import("#nuxt-i18n/96a088e8" /* webpackChunkName: "locale_dv_46json_96a088e8" */),
      cache: true
    }
  ],
  hy: [
    {
      key: "locale_hy_46json_49aa6614",
      load: () => import("#nuxt-i18n/49aa6614" /* webpackChunkName: "locale_hy_46json_49aa6614" */),
      cache: true
    }
  ],
  sq: [
    {
      key: "locale_sq_46json_e3f8e190",
      load: () => import("#nuxt-i18n/e3f8e190" /* webpackChunkName: "locale_sq_46json_e3f8e190" */),
      cache: true
    }
  ],
  bs: [
    {
      key: "locale_bs_46json_e722c354",
      load: () => import("#nuxt-i18n/e722c354" /* webpackChunkName: "locale_bs_46json_e722c354" */),
      cache: true
    }
  ],
  sr: [
    {
      key: "locale_sr_46json_32e8bfac",
      load: () => import("#nuxt-i18n/32e8bfac" /* webpackChunkName: "locale_sr_46json_32e8bfac" */),
      cache: true
    }
  ],
  ka: [
    {
      key: "locale_ka_46json_24b913e8",
      load: () => import("#nuxt-i18n/24b913e8" /* webpackChunkName: "locale_ka_46json_24b913e8" */),
      cache: true
    }
  ],
  ne: [
    {
      key: "locale_ne_46json_764efcb5",
      load: () => import("#nuxt-i18n/764efcb5" /* webpackChunkName: "locale_ne_46json_764efcb5" */),
      cache: true
    }
  ],
  vi: [
    {
      key: "locale_vi_46json_332c068d",
      load: () => import("#nuxt-i18n/332c068d" /* webpackChunkName: "locale_vi_46json_332c068d" */),
      cache: true
    }
  ],
  ko: [
    {
      key: "locale_ko_46json_8874cf7c",
      load: () => import("#nuxt-i18n/8874cf7c" /* webpackChunkName: "locale_ko_46json_8874cf7c" */),
      cache: true
    }
  ],
  he: [
    {
      key: "locale_he_46json_27cd6006",
      load: () => import("#nuxt-i18n/27cd6006" /* webpackChunkName: "locale_he_46json_27cd6006" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    jit: true,
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en-us",
      iso: "en",
      language: "en",
      name: "English",
      files: [
        "/builds/sbt/smsbat/i18n/locales/en.json"
      ]
    },
    {
      code: "uk-ua",
      iso: "uk",
      language: "uk",
      name: "Українська",
      files: [
        "/builds/sbt/smsbat/i18n/locales/ua.json"
      ]
    },
    {
      code: "bg",
      iso: "bg",
      language: "bg",
      name: "Български",
      files: [
        "/builds/sbt/smsbat/i18n/locales/bg.json"
      ]
    },
    {
      code: "hr",
      iso: "hr",
      language: "hr",
      name: "Hrvatski",
      files: [
        "/builds/sbt/smsbat/i18n/locales/hr.json"
      ]
    },
    {
      code: "cs",
      iso: "cs",
      language: "cs",
      name: "Čeština",
      files: [
        "/builds/sbt/smsbat/i18n/locales/cs.json"
      ]
    },
    {
      code: "da",
      iso: "da",
      language: "da",
      name: "Dansk",
      files: [
        "/builds/sbt/smsbat/i18n/locales/da.json"
      ]
    },
    {
      code: "nl",
      iso: "nl",
      language: "nl",
      name: "Nederlands",
      files: [
        "/builds/sbt/smsbat/i18n/locales/nl.json"
      ]
    },
    {
      code: "et",
      iso: "et",
      language: "et",
      name: "Eesti",
      files: [
        "/builds/sbt/smsbat/i18n/locales/et.json"
      ]
    },
    {
      code: "fi",
      iso: "fi",
      language: "fi",
      name: "Suomi",
      files: [
        "/builds/sbt/smsbat/i18n/locales/fi.json"
      ]
    },
    {
      code: "fr",
      iso: "fr",
      language: "fr",
      name: "Français",
      files: [
        "/builds/sbt/smsbat/i18n/locales/fr.json"
      ]
    },
    {
      code: "de",
      iso: "de",
      language: "de",
      name: "Deutsch",
      files: [
        "/builds/sbt/smsbat/i18n/locales/de.json"
      ]
    },
    {
      code: "el",
      iso: "el",
      language: "el",
      name: "Ελληνικά",
      files: [
        "/builds/sbt/smsbat/i18n/locales/el.json"
      ]
    },
    {
      code: "hu",
      iso: "hu",
      language: "hu",
      name: "Magyar",
      files: [
        "/builds/sbt/smsbat/i18n/locales/hu.json"
      ]
    },
    {
      code: "ga",
      iso: "ga",
      language: "ga",
      name: "Gaeilge",
      files: [
        "/builds/sbt/smsbat/i18n/locales/ga.json"
      ]
    },
    {
      code: "it",
      iso: "it",
      language: "it",
      name: "Italiano",
      files: [
        "/builds/sbt/smsbat/i18n/locales/it.json"
      ]
    },
    {
      code: "lv",
      iso: "lv",
      language: "lv",
      name: "Latviešu",
      files: [
        "/builds/sbt/smsbat/i18n/locales/lv.json"
      ]
    },
    {
      code: "lt",
      iso: "lt",
      language: "lt",
      name: "Lietuvių",
      files: [
        "/builds/sbt/smsbat/i18n/locales/lt.json"
      ]
    },
    {
      code: "mt",
      iso: "mt",
      language: "mt",
      name: "Malti",
      files: [
        "/builds/sbt/smsbat/i18n/locales/mt.json"
      ]
    },
    {
      code: "pl",
      iso: "pl",
      language: "pl",
      name: "Polski",
      files: [
        "/builds/sbt/smsbat/i18n/locales/pl.json"
      ]
    },
    {
      code: "pt",
      iso: "pt",
      language: "pt",
      name: "Português",
      files: [
        "/builds/sbt/smsbat/i18n/locales/pt.json"
      ]
    },
    {
      code: "ro",
      iso: "ro",
      language: "ro",
      name: "Română",
      files: [
        "/builds/sbt/smsbat/i18n/locales/ro.json"
      ]
    },
    {
      code: "sk",
      iso: "sk",
      language: "sk",
      name: "Slovenčina",
      files: [
        "/builds/sbt/smsbat/i18n/locales/sk.json"
      ]
    },
    {
      code: "sl",
      iso: "sl",
      language: "sl",
      name: "Slovenščina",
      files: [
        "/builds/sbt/smsbat/i18n/locales/sl.json"
      ]
    },
    {
      code: "es",
      iso: "es",
      language: "es",
      name: "Español",
      files: [
        "/builds/sbt/smsbat/i18n/locales/es.json"
      ]
    },
    {
      code: "sv",
      iso: "sv",
      language: "sv",
      name: "Svenska",
      files: [
        "/builds/sbt/smsbat/i18n/locales/sv.json"
      ]
    },
    {
      code: "tr",
      iso: "tr",
      language: "tr",
      name: "Türkçe",
      files: [
        "/builds/sbt/smsbat/i18n/locales/tr.json"
      ]
    },
    {
      code: "my",
      iso: "my",
      language: "my",
      name: "မြန်မာစာ",
      files: [
        "/builds/sbt/smsbat/i18n/locales/my.json"
      ]
    },
    {
      code: "fil",
      iso: "fil",
      language: "fil",
      name: "Filipino",
      files: [
        "/builds/sbt/smsbat/i18n/locales/fil.json"
      ]
    },
    {
      code: "ro-md",
      iso: "ro-MD",
      language: "ro-MD",
      name: "Română (Moldova)",
      files: [
        "/builds/sbt/smsbat/i18n/locales/ro-md.json"
      ]
    },
    {
      code: "dv",
      iso: "dv",
      language: "dv",
      name: "ދިވެހި",
      dir: "rtl",
      files: [
        "/builds/sbt/smsbat/i18n/locales/dv.json"
      ]
    },
    {
      code: "hy",
      iso: "hy",
      language: "hy",
      name: "Հայերեն",
      files: [
        "/builds/sbt/smsbat/i18n/locales/hy.json"
      ]
    },
    {
      code: "sq",
      iso: "sq",
      language: "sq",
      name: "Shqip",
      files: [
        "/builds/sbt/smsbat/i18n/locales/sq.json"
      ]
    },
    {
      code: "bs",
      iso: "bs",
      language: "bs",
      name: "Bosanski",
      files: [
        "/builds/sbt/smsbat/i18n/locales/bs.json"
      ]
    },
    {
      code: "sr",
      iso: "sr",
      language: "sr",
      name: "Српски",
      files: [
        "/builds/sbt/smsbat/i18n/locales/sr.json"
      ]
    },
    {
      code: "ka",
      iso: "ka",
      language: "ka",
      name: "ქართული",
      files: [
        "/builds/sbt/smsbat/i18n/locales/ka.json"
      ]
    },
    {
      code: "ne",
      iso: "ne",
      language: "ne",
      name: "नेपाली",
      files: [
        "/builds/sbt/smsbat/i18n/locales/ne.json"
      ]
    },
    {
      code: "vi",
      iso: "vi",
      language: "vi",
      name: "Tiếng Việt",
      files: [
        "/builds/sbt/smsbat/i18n/locales/vi.json"
      ]
    },
    {
      code: "ko",
      iso: "ko",
      language: "ko",
      name: "한국어",
      files: [
        "/builds/sbt/smsbat/i18n/locales/ko.json"
      ]
    },
    {
      code: "he",
      iso: "he",
      language: "he",
      name: "עברית",
      dir: "rtl",
      files: [
        "/builds/sbt/smsbat/i18n/locales/he.json"
      ]
    }
  ],
  defaultLocale: "en-us",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "https://smsbat.com",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en-us",
    iso: "en",
    language: "en",
    name: "English",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "uk-ua",
    iso: "uk",
    language: "uk",
    name: "Українська",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/ua.json",
        cache: undefined
      }
    ]
  },
  {
    code: "bg",
    iso: "bg",
    language: "bg",
    name: "Български",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/bg.json",
        cache: undefined
      }
    ]
  },
  {
    code: "hr",
    iso: "hr",
    language: "hr",
    name: "Hrvatski",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/hr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "cs",
    iso: "cs",
    language: "cs",
    name: "Čeština",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/cs.json",
        cache: undefined
      }
    ]
  },
  {
    code: "da",
    iso: "da",
    language: "da",
    name: "Dansk",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/da.json",
        cache: undefined
      }
    ]
  },
  {
    code: "nl",
    iso: "nl",
    language: "nl",
    name: "Nederlands",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/nl.json",
        cache: undefined
      }
    ]
  },
  {
    code: "et",
    iso: "et",
    language: "et",
    name: "Eesti",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/et.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fi",
    iso: "fi",
    language: "fi",
    name: "Suomi",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/fi.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    iso: "fr",
    language: "fr",
    name: "Français",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/fr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    iso: "de",
    language: "de",
    name: "Deutsch",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "el",
    iso: "el",
    language: "el",
    name: "Ελληνικά",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/el.json",
        cache: undefined
      }
    ]
  },
  {
    code: "hu",
    iso: "hu",
    language: "hu",
    name: "Magyar",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/hu.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ga",
    iso: "ga",
    language: "ga",
    name: "Gaeilge",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/ga.json",
        cache: undefined
      }
    ]
  },
  {
    code: "it",
    iso: "it",
    language: "it",
    name: "Italiano",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/it.json",
        cache: undefined
      }
    ]
  },
  {
    code: "lv",
    iso: "lv",
    language: "lv",
    name: "Latviešu",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/lv.json",
        cache: undefined
      }
    ]
  },
  {
    code: "lt",
    iso: "lt",
    language: "lt",
    name: "Lietuvių",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/lt.json",
        cache: undefined
      }
    ]
  },
  {
    code: "mt",
    iso: "mt",
    language: "mt",
    name: "Malti",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/mt.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pl",
    iso: "pl",
    language: "pl",
    name: "Polski",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/pl.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pt",
    iso: "pt",
    language: "pt",
    name: "Português",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/pt.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ro",
    iso: "ro",
    language: "ro",
    name: "Română",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/ro.json",
        cache: undefined
      }
    ]
  },
  {
    code: "sk",
    iso: "sk",
    language: "sk",
    name: "Slovenčina",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/sk.json",
        cache: undefined
      }
    ]
  },
  {
    code: "sl",
    iso: "sl",
    language: "sl",
    name: "Slovenščina",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/sl.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    iso: "es",
    language: "es",
    name: "Español",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/es.json",
        cache: undefined
      }
    ]
  },
  {
    code: "sv",
    iso: "sv",
    language: "sv",
    name: "Svenska",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/sv.json",
        cache: undefined
      }
    ]
  },
  {
    code: "tr",
    iso: "tr",
    language: "tr",
    name: "Türkçe",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/tr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "my",
    iso: "my",
    language: "my",
    name: "မြန်မာစာ",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/my.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fil",
    iso: "fil",
    language: "fil",
    name: "Filipino",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/fil.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ro-md",
    iso: "ro-MD",
    language: "ro-MD",
    name: "Română (Moldova)",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/ro-md.json",
        cache: undefined
      }
    ]
  },
  {
    code: "dv",
    iso: "dv",
    language: "dv",
    name: "ދިވެހި",
    dir: "rtl",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/dv.json",
        cache: undefined
      }
    ]
  },
  {
    code: "hy",
    iso: "hy",
    language: "hy",
    name: "Հայերեն",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/hy.json",
        cache: undefined
      }
    ]
  },
  {
    code: "sq",
    iso: "sq",
    language: "sq",
    name: "Shqip",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/sq.json",
        cache: undefined
      }
    ]
  },
  {
    code: "bs",
    iso: "bs",
    language: "bs",
    name: "Bosanski",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/bs.json",
        cache: undefined
      }
    ]
  },
  {
    code: "sr",
    iso: "sr",
    language: "sr",
    name: "Српски",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/sr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ka",
    iso: "ka",
    language: "ka",
    name: "ქართული",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/ka.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ne",
    iso: "ne",
    language: "ne",
    name: "नेपाली",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/ne.json",
        cache: undefined
      }
    ]
  },
  {
    code: "vi",
    iso: "vi",
    language: "vi",
    name: "Tiếng Việt",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/vi.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ko",
    iso: "ko",
    language: "ko",
    name: "한국어",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/ko.json",
        cache: undefined
      }
    ]
  },
  {
    code: "he",
    iso: "he",
    language: "he",
    name: "עברית",
    dir: "rtl",
    files: [
      {
        path: "/builds/sbt/smsbat/i18n/locales/he.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/